import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUpLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-up-left"><path d="M5.75 15.25V5.75H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.0001 18L6.3999 6.39978" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowUpLeft;
